import React, { Component } from 'react';
import { v4 as uuid } from 'uuid';
import {
  Search,
  DataTable,
  Footer,
  TextInput,
  Select,
  SelectItem,
  ContentSwitcher,
  Switch,
  ButtonSkeleton,
  Toggle,
  Tabs,
  Tab,
  SkeletonPlaceholder,
  Loading,
  DataTableSkeleton,
  TableContainer,
  Pagination,
  Form,
  Checkbox,
  DatePicker,
  DatePickerInput,
  FormLabel,
  FormGroup,
  ModalWrapper,
  TableHead,
  Table,
  DropdownSkeleton,
  TextArea,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Accordion,
  AccordionItem,
  TableBody,
  TableRow,
  TableCell,
  TableHeader,
  TableToolbarAction,
  TableToolbar,
  TableToolbarContent,
  TableToolbarMenu,
  Button,
  SkeletonText,
} from 'carbon-components-react';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Chevrondown16 from '@carbon/icons-react/lib/chevron--down/16';
import { CheckmarkOutline16, CheckmarkFilled20, Download16 } from '@carbon/icons-react/lib/';
import { api, dynamic } from '../../helpers/api/api';

import {
  RenderDataTableCell,
  NoRecordsPlaceholder,
} from '../../helpers/jsonschemaform/DataTableExtention';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  entitiesLabels,
  apioperation,
  DateFormat,
  BEDateFormat,
} from '../../helpers/Constants';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import SimpleReactValidator from 'simple-react-validator';
import moment, { invalid } from 'moment';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import DateTimePicker from '../../helpers/DateTimePicker';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import { Online } from '../common/OnLineOffLine';
import FileDownLoadButton from '../common/FileDownloadButton';

const baseUrl = '/worksite/';
const worksite = {
  id: undefined,
  code: '',
  name: '',
  idDivision: undefined,
  idWorkSiteGroup: undefined,
  isEnabledForEnvironment: false,
  isOffshore: false,
  isSaipem: false,
  //obsolete: false,
  start: null,
  end: null,
  workSiteProjects: [],
};
const workSiteProjectItem = {
  id: undefined,
  comments: '',
  start: null,
  end: null,
  idWorkSite: undefined,
  idProject: null,
  idDivision: null,
  idSubDivision: null,
  idCompany: null,
  idActivity: null,
  idCountry: null,
  isRegisteredOffice: null,
  hseConsolidated: false,
  underFinControl: null, //RITM1398834
  underOpControl: null, //RITM1398834
};
const workSiteProjectsDTHeaders = [
  { key: 'start', header: 'Start', type: 'date' },
  { key: 'end', header: 'End', type: 'date' },
  { key: 'project', header: 'Prj' },
  { key: 'country', header: 'Country' },
  //RITM0945977
  // { key: 'division', header: 'Division' },
  // { key: 'subDivision', header: 'SubDivision' },
  { key: 'division', header: 'Business Line' },
  { key: 'subDivision', header: 'Sub-Business Line' },
  { key: 'company', header: 'Operating Company/Branch' },
  { key: 'isRegisteredOffice', header: 'Local Crisis Unit Registered Office', type: 'bool' },
  { key: 'hseConsolidated', header: 'HSE Consolidated', type: 'bool' },
  
    { key: 'underFinControl', header: 'Under Financial Control' },//RITM1398834
    { key: 'underOpControl', header: 'Under Operational Control' },//RITM1398834
  //{ key: 'inUse', header: 'In Use', 'type': 'bool' },
];

const searchProp = {
  //refyear
  search: '',
  idDivision: null,
  idWorkSiteGroup: null,
  inUse: null,
  //isObsolete: null,
};

export class WorkSite extends Component {
  constructor(props) {
    super(props);
    this.toggleSearchForm = this.toggleSearchForm.bind(this);
    this.updateState = this.updateState.bind(this);
    this.handleClickCancelSearch = this.handleClickCancelSearch.bind(this);
    this.validator = new SimpleReactValidator();
    this.validatorWP = new SimpleReactValidator();
    this.state = {
      itemList: [],
      appMainDivision: [],
      appWorkSiteGroup: [],
      appProject: [],
      appCountry: [],
      appDivision: [],
      appSubDivision: [],
      appCompany: [],
      appActivity: [],
      idWorkSiteEdit: null,
      idToDelete: null,
      worksiteModel: {
        ...worksite,
      },
      workSiteProjectModel: {
        ...workSiteProjectItem,
      },
      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
      search: {
        ...searchProp,
      },
      isLoadingList: true,
      isLoadingMainDivision: null,
      isLoadingDivision: null,
      isLoadingProject: null,
      isLoadingCountry: null,
      isLoadingSubDivision: null,
      isLoadingCompany: null,
      isLoadingActivity: null,
      isLoadingWorkSiteGroup: null,
      isLoadingWorkSiteData: false,
      isSubmitted: false,
      isEditModal: false,
      isEditModalWorkSitePrj: false,
      isOpenSearchForm: false,
      isOpenModal: false,
      isOpenInsertModal: false,
      isOpenDeleteModal: false,
      isDeleting: false,
    };
  }

  componentDidMount() {
    this.getWorkSiteList();
    this.getMainDivision();
    this.getWorkSiteGroup();

    this.getProject();
    this.getCountry();
    this.getDivision();
    this.getAllSubDivision();
    this.getCompany();
    this.getAllActivity();
  }

  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  /*************API********************/
  getWorkSiteList(param) {
    this.setState({ isLoadingList: true });

    const data = {
      params: {
        page: param && param.page ? param.page : this.state.currentPage,
        pageSize: param && param.pageSize ? param.pageSize : this.state.pageSize,
        ...this.state.search,
      },
    };

    api
      .getWithParam(baseUrl, data)
      .then((response) => {
        this.setState({
          ...response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.WORKSITE, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingList: false,
        });
      });
  }

  getMainDivision() {
    this.setState({ isLoadingMainDivision: true });

    api
      .getAll('/division/main')
      .then((response) => {
        var data = response.data;

        data = data != null ? data.map((item) => ({ value: item.id, label: item.name })) : [];
        this.setState({
          appMainDivision: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.MAINDIVISION, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingMainDivision: false,
        });
      });
  }

  getWorkSiteGroup() {
    this.setState({ isLoadingWorkSiteGroup: true });

    dynamic
      .getAll('worksitegroup', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;

        data = data != null ? data.map((item) => ({ value: item.id, label: item.name })) : [];
        this.setState({
          appWorkSiteGroup: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.WORKSITEGROUP, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingWorkSiteGroup: false,
        });
      });
  }

  getProject() {
    this.setState({ isLoadingProject: true });

    dynamic
      .getAll('project', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;

        data =
          data != null
            ? data.map((item) => ({
                value: item.id,
                label: item.name + (item.inUse ? '' : ' [Not In Use]'),
                inUse: item.inUse,
                consolidatedProject: item.consolidatedProject,
              }))
            : [];
        this.setState({
          appProject: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.PROJECT, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingProject: false,
        });
      });
  }

  getCountry() {
    this.setState({ isLoadingCountry: true });

    api
      .getAll('/country')
      .then((response) => {
        var data = response.data;

        data = data != null ? data.map((item) => ({ value: item.id, label: item.name })) : [];
        this.setState({
          appCountry: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.COUNTRY, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingCountry: false,
        });
      });
  }

  getDivision() {
    this.setState({ isLoadingDivision: true });

    dynamic
      .getAll('division', { params: { page: 0 } })
      .then((response) => {
        var data = response.data.itemList;

        data = data != null ? data.map((item) => ({ value: item.id, label: item.name })) : [];
        this.setState({
          appDivision: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.DIVISION, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingDivision: false,
        });
      });
  }

  getAllSubDivision() {
    this.setState({ isLoadingSubDivision: true });

    api
      .getAll('/division/subdivision')
      .then((response) => {
        var data = response.data;
        //todo fare mapping se serve
        data =
          data != null
            ? data.map((item) => ({
                value: item.id,
                label: item.name,
                idDivision: item.idDivision,
              }))
            : [];
        this.setState({
          appSubDivision: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.SUBDIVISION, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingSubDivision: false,
        });
      });
  }

  getCompany() {
    this.setState({ isLoadingCompany: true });

    api
      .getAll('/company')
      .then((response) => {
        var data = response.data;

        data = data != null ? data.map((item) => ({ value: item.id, label: item.name })) : [];
        this.setState({
          appCompany: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.COMPANY, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingCompany: false,
        });
      });
  }

  getAllActivity() {
    this.setState({ isLoadingActivity: true });

    api
      .getAll('/activity')
      .then((response) => {
        var data = response.data;

        data =
          data != null
            ? data.map((item) => ({
                value: item.id,
                label: item.name,
                idDivision: item.idDivision,
              }))
            : [];
        this.setState({
          appActivity: data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.ACTIVITY, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingActivity: false,
        });
      });
  }

  getWorkSiteForEdit(id) {
    this.setState({
      isEditModal: true,
      isLoadingWorkSiteData: true,
      isOpenInsertModal: true,
    });

    api
      .get(baseUrl, id)
      .then((response) => {
        this.setState({
          idWorkSiteEdit: id,
          worksiteModel: response.data,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.WORKSITE, apioperation.GET));
      })
      .finally(() => {
        this.setState(
          {
            isLoadingWorkSiteData: false,
          },
          () => {
            //this.getSelectedEntityRoles();
          }
        );
      });
  }

  /*************API********************/

  /*************Form Ricerca********************/
  toggleSearchForm(e) {
    e.preventDefault();
    this.setState((oldState) => ({ isOpenSearchForm: !oldState.isOpenSearchForm }));
  }

  handleChangeSearch = (el) => {
    let inputName = el.target.name;
    let inputValue = el.target.value;
    this.updateState(inputName, inputValue, 'search');
  };

  handleClickSearch = (e) => {
    e.preventDefault();
    this.getWorkSiteList({ page: 1 });
  };

  handleClickCancelSearch = (e) => {
    e.preventDefault();
    this.setState(
      {
        search: {
          ...searchProp,
        },
      },
      () => {
        this.getWorkSiteList({ page: 1 });
      }
    );
  };

  handleChangePaging = (event) => {
    this.getWorkSiteList(event);
  };

  /*************Form Ricerca********************/

  /*************Form worksite********************/
  handleChangeModel = (el) => {
    let inputName = el.target.name;
    let inputValue = el.target.value;
    this.updateState(inputName, inputValue, 'worksiteModel');
  };

  handleChangeAsset = (value) => {
    if (!value) {
      this.updateState('assetPortfolio', false, 'worksiteModel');
    }
    this.updateState('asset', value, 'worksiteModel');
  };

  clearInsertForm = () => {
    this.setState({
      worksiteModel: Object.assign({}, worksite),
      isSubmitted: false,
    });
    this.validator.hideMessages();
    this.validatorWP.hideMessages();
  };

  handleSubmitInsert = () => {
    if (this.validator.allValid()) {
      let datiForm = this.state.worksiteModel;

      this.setState({
        isSubmitted: true,
      });

      let id = this.state.idWorkSiteEdit;
      let method = this.state.isEditModal
        ? api.put(baseUrl, datiForm, id)
        : api.post(baseUrl, datiForm);

      method
        .then((response) => {
          if (response.status == 200) {
            this.getWorkSiteList();
            this.clearInsertForm();
            this.setState({
              isOpenInsertModal: false,
            });
            showNotification.success(`${entitiesLabels.SUCCESS}`,
              getSuccess(
                entitiesLabels.WORKSITE,
                this.state.isEditModal ? apioperation.PUT : apioperation.POST
              )
            );
          } else {
            showNotification.error();
          }
        })
        .catch((error) => {
          showNotification.error(
            getError(
              error,
              entitiesLabels.WORKSITE,
              this.state.isEditModal ? apioperation.PUT : apioperation.POST
            )
          );
        })
        .finally(() => {
          this.setState({
            isSubmitted: false,
          });
        });
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.WORKSITE + ' required fields are missing  '
      );
      this.forceUpdate();
    }
  };

  confirmDelete = (id) => {
    this.setState({
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  onCloseConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  deleteItem = () => {
    let id = this.state.idToDelete;
    this.setState({
      isDeleting: true,
    });
    api
      .delete(baseUrl, id)
      .then((response) => {
        if (response.status == 200) {
          this.setState({
            idToDelete: null,
            isOpenDeleteModal: false,
          });
          this.onCloseConfirm();
          this.getWorkSiteList();
          showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.WORKSITE, apioperation.DELETE));
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.WORKSITE, apioperation.DELETE));
      })
      .finally(() => {
        this.setState({
          isDeleting: false,
        });
      });
  };

  getNameById = (id) => {
    if (id == null) return '';
    let element = this.state.itemList.find((el) => el.id == id);
    return element != null ? element.name : '';
  };

  addNewWorkSite() {
    this.clearInsertForm();

    this.setState({
      isEditModal: false,
      isOpenInsertModal: true,
    });
  }

  closeInsertForm() {
    this.setState({
      isOpenInsertModal: false,
    });
    this.validator.hideMessages();
  }

  downloadFile() {
    if (this.state.isExportLoading) return;

    this.setState({
      isExportLoading: true,
    });
    api
      .getWithParam(baseUrl + 'excel', { responseType: 'arraybuffer' })
      .then((response) => {
        //fileDownload(new Blob([response.data]), 'report.xlsx');
        var data = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var csvURL = window.URL.createObjectURL(data);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;

        var nomefile = 'Export_' + 'Worksite_' + moment().format('YYYYMMDDHHmmSS') + '.xlsx';
        tempLink.setAttribute('download', nomefile);

        document.body.appendChild(tempLink);
        tempLink.click();
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, 'Download File', apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isExportLoading: false,
        });
      });
  }

  /*************Form worksite********************/
  /*************Form worksiteproject********************/
  handleChangeWksProjModel = (el) => {
    let inputName = el.target.name;
    let inputValue = el.target.value;
    this.updateState(inputName, inputValue, 'workSiteProjectModel');

    if(inputName !== 'underFinControl' && this.state.workSiteProjectModel.underFinControl == null)  this.updateState('underFinControl', 'TBD', 'workSiteProjectModel'); //RITM1398834
    if(inputName !== 'underOpControl' && this.state.workSiteProjectModel.underOpControl == null) this.updateState('underOpControl', 'TBD', 'workSiteProjectModel'); //RITM1398834
  };

  toggleModal = (open) => {
    this.setState({ isOpenModal: open });
  };

  addNewWorkSitePrj = () => {
    this.setState({
      workSiteProjectModel: {
        ...workSiteProjectItem,
      },
      isOpenModal: true,
      isEditModalWorkSitePrj: false,
    });
  };

  getWorkSitePrjForEdit = (id) => {
    const workSiteProjects = this.state.worksiteModel.workSiteProjects || [];
    const element = workSiteProjects.find((el) => el.id == id);
    if (element != null) {
      this.setState({
        workSiteProjectModel: {
          ...element,
        },
        isOpenModal: true,
        isEditModalWorkSitePrj: true,
      });
    } else {
      showNotification.error('Element not found');
    }
  };

  saveWorkSitePrj = () => {
    if (this.validatorWP.allValid()) {
      let datiForm = this.state.workSiteProjectModel;

      let worksite = this.state.worksiteModel;

      var dateFStart = moment(datiForm.start);
      var dateFEnd = moment(datiForm.end);
      var dateWStart = moment(worksite.start);
      var dateWEnd = moment(worksite.end);

      if (
        !(
          dateFStart.isSameOrBefore(dateFEnd) &&
          dateWStart.isSameOrBefore(dateFStart) &&
          dateFEnd.isSameOrBefore(dateWEnd)
        )
      ) {
        showNotification.error('Date Start or Date End not valid');
        return;
      }

      try {
        //recupero nome entità da visualizzare in datatable
        datiForm.project =
          this.state.appProject.find((x) => x.value == datiForm.idProject).label || '';
        datiForm.country =
          this.state.appCountry.find((x) => x.value == datiForm.idCountry).label || '';
        datiForm.division =
          this.state.appDivision.find((x) => x.value == datiForm.idDivision).label || '';
        datiForm.subDivision =
          this.state.appSubDivision.find((x) => x.value == datiForm.idSubDivision).label || '';
        datiForm.company =
          this.state.appCompany.find((x) => x.value == datiForm.idCompany).label || '';
          let oldWorkSiteProjects = this.state.worksiteModel.workSiteProjects || [];
          datiForm.isRegisteredOffice = this.state.workSiteProjectModel?.isRegisteredOffice == undefined ? false : this.state.workSiteProjectModel.isRegisteredOffice;
          datiForm.hseConsolidated = this.state.workSiteProjectModel?.hseConsolidated == undefined ? false : this.state.workSiteProjectModel.hseConsolidated;
          datiForm.underFinControl = this.state.workSiteProjectModel?.underFinControl == null ? 'TBD' : this.state.workSiteProjectModel.underFinControl; //RITM1398834
          datiForm.underOpControl = this.state.workSiteProjectModel?.underOpControl == null ? 'TBD' : this.state.workSiteProjectModel.underOpControl; //RITM1398834
          
          if (this.state.isEditModalWorkSitePrj) {
          //edit
          let id = datiForm.id;
          let indexElement = oldWorkSiteProjects.findIndex((el) => el.id == id);
          if (indexElement > -1) {
            let newWorkSiteProjects = [...oldWorkSiteProjects];
            newWorkSiteProjects[indexElement] = datiForm;
            this.updateState('workSiteProjects', newWorkSiteProjects, 'worksiteModel');
          }
        } else {
          //insert
          const newid = uuid();
          datiForm.id = newid;
          let newWorkSiteProjects = oldWorkSiteProjects.concat([datiForm]);
          this.updateState('workSiteProjects', newWorkSiteProjects, 'worksiteModel');
        }

        //fine
        this.setState({
          isOpenModal: false,
        });
      } catch {
        showNotification.error('saveWorkSitePrj failed');
      }
    } else {
      this.validatorWP.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,entitiesLabels.WORKSITEPROJECT + ' required fields are missing  '
      );
      this.forceUpdate();
    }
  };

  /*************Form worksiteproject********************/
  /*************Render********************/
  showLoading() {
    let show =
      (this.state.isEditModal && this.state.isLoadingWorkSiteData) || this.state.isSubmitted;
    let descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active={true} withOverlay={true} description={descr} />;
    //return (<InlineLoading className="bx--loading-overlay" {...props} />)
  }

  renderSearchform() {
    return (
      this.state.isOpenSearchForm && (
        <div>
          <Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>
            <FormGroup legendText="" className="bx--col-md-4">
              <FormLabel>Code / Name</FormLabel>
              <TextInput
                id="inputsearch"
                name="search"
                value={this.state.search.search}
                onChange={this.handleChangeSearch}
                placeholder="Input Code / Name"
                type="text"
                labelText=""
                className="bx--text-input some-class bx--text-input--light"
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4">
              {/* RITM0945977 */}
              {/* <FormLabel>Main Division</FormLabel> */}
              <FormLabel>Main Business Line</FormLabel>
              {this.state.isLoadingMainDivision ? (
                <DropdownSkeleton />
              ) : (
                <Select
                  id="inputsearchidDivision"
                  name="idDivision"
                  className="max-width"
                  value={this.state.search.idDivision || ''}
                  light={true}
                  inline={false}
                  hideLabel={true}
                  onChange={this.handleChangeSearch}
                >
                  <SelectItem value="" text="All" />
                  {this.state.appMainDivision.map(({ value, label }, i) => {
                    return <SelectItem key={i} value={value} text={label} />;
                  })}
                </Select>
              )}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4">
              <FormLabel>WorkSite Group</FormLabel>
              {this.state.isLoadingWorkSiteGroup ? (
                <DropdownSkeleton />
              ) : (
                <Select
                  id="inputsearchidWorkSiteGroup"
                  name="idWorkSiteGroup"
                  className="max-width"
                  value={this.state.search.idWorkSiteGroup || ''}
                  light={true}
                  inline={false}
                  hideLabel={true}
                  onChange={this.handleChangeSearch}
                >
                  <SelectItem value="" text="All" />
                  {this.state.appWorkSiteGroup.map(({ value, label }, i) => {
                    return <SelectItem key={i} value={value} text={label} />;
                  })}
                </Select>
              )}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4">
              <FormLabel>In Use</FormLabel>
              <Select
                id="inputinUse"
                name="inUse"
                className="max-width"
                value={this.state.search.inUse || ''}
                light={true}
                inline={false}
                hideLabel={true}
                onChange={this.handleChangeSearch}
              >
                <SelectItem key="all" value="" text="All" />
                <SelectItem key="yes" value={true} text="Yes" />
                <SelectItem key="no" value={false} text="No" />
              </Select>
            </FormGroup>

            {/* <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel >Is Obsolete</FormLabel>
                        <Select
                            id="inputisObsolete"
                            name="isObsolete"
                            className="max-width"
                            value={this.state.search.isObsolete || ''}
                            light={true}
                            inline={false}
                            hideLabel={true}
                            onChange={this.handleChangeSearch}
                        >
                            <SelectItem key="all" value="" text="All" />
                            <SelectItem key="yes" value={true} text="Yes" />
                            <SelectItem key="no" value={false} text="No" />
                        </Select>
                    </FormGroup> */}
          </Form>
          <div className="searchFormFooter">
            <Button
              className="button--max-width"
              size="small"
              kind="secondary"
              onClick={this.handleClickCancelSearch}
            >
              Cancel
            </Button>
            <Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
              Search
            </Button>
          </div>
        </div>
      )
    );
  }

  renderInsertForm() {
    const validations = {
      code: this.validator.message('Code', this.state.worksiteModel.code, 'required'),
      name: this.validator.message('Name', this.state.worksiteModel.name, 'required'),
      // idDivision: this.validator.message(
      //   'Division',
      //   this.state.worksiteModel.idDivision,
      //   'required'
      // ), //RITM0945977
      idDivision: this.validator.message(
        'businessLine',
        this.state.worksiteModel.idDivision,
        'required'
      ),
      idWorkSiteGroup: this.validator.message(
        'WorksiteGroup',
        this.state.worksiteModel.idWorkSiteGroup,
        'required'
      ),
      start: this.validator.message('StartDate', this.state.worksiteModel.start, 'required'),
      end: this.validator.message('EndDate', this.state.worksiteModel.end, 'required'),
      endAfterStart: this.validator.message(
        'endAfterStart',
        this.state.worksiteModel.end == null ||
          this.state.worksiteModel.start == null ||
          moment(this.state.worksiteModel.end).isSameOrAfter(
            moment(this.state.worksiteModel.start),
            'day'
          ),
        'accepted'
      ),
    };

    return (
      <div className="insert-user-form">
        <Form className="bx--grid--full-width">
          {this.showLoading()}

          <div className="bx--row">
            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel>Code*</FormLabel>
              <TextInput
                id="modelcode"
                name="code"
                placeholder="Input code"
                required
                value={this.state.worksiteModel.code}
                onChange={this.handleChangeModel}
                invalid={validations.code != null}
                type="text"
                labelText=""
                className="bx--text-input  bx--text-input--light"
                disabled={false}
              />
              {validations.code}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel>Name*</FormLabel>
              <TextInput
                id="modelname"
                name="name"
                placeholder="Input name"
                required
                value={this.state.worksiteModel.name}
                onChange={this.handleChangeModel}
                invalid={validations.name != null}
                type="text"
                labelText=""
                className="bx--text-input  bx--text-input--light"
                disabled={false}
              />
              {validations.name}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              {/* RITM0945977 */}
              {/* <FormLabel>Main Division*</FormLabel> */}
              <FormLabel>Main Business Line*</FormLabel>
              {this.state.isLoadingMainDivision ? (
                <DropdownSkeleton />
              ) : (
                <Select
                  id="inputidDivision"
                  name="idDivision"
                  className="max-width"
                  value={this.state.worksiteModel.idDivision || ''}
                  light={true}
                  inline={false}
                  hideLabel={true}
                  invalid={validations.idDivision != null}
                  onChange={this.handleChangeModel}
                >
                  <SelectItem value="" text="" />
                  {this.state.appMainDivision.map(({ value, label }, i) => {
                    return <SelectItem key={i} value={value} text={label} />;
                  })}
                </Select>
              )}
              {validations.idDivision}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel>WorkSite Group*</FormLabel>
              {this.state.isLoadingWorkSiteGroup ? (
                <DropdownSkeleton />
              ) : (
                <Select
                  id="inputidWorkSiteGroup"
                  name="idWorkSiteGroup"
                  className="max-width"
                  value={this.state.worksiteModel.idWorkSiteGroup || ''}
                  light={true}
                  inline={false}
                  hideLabel={true}
                  onChange={this.handleChangeModel}
                >
                  <SelectItem value="" text="" />
                  {this.state.appWorkSiteGroup.map(({ value, label }, i) => {
                    return <SelectItem key={i} value={value} text={label} />;
                  })}
                </Select>
              )}
              {validations.idWorkSiteGroup}
            </FormGroup>
            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel>Date Start*</FormLabel>

              <DateTimePicker
                value={this.state.worksiteModel.start}
                type="date"
                placeholder={DateFormat}
                name="start"
                alt="worksiteModel"
                invalid={validations.start != null}
                onChange={this.updateState}
              />
              {validations.start}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
              <FormLabel>Date End*</FormLabel>

              <DateTimePicker
                value={this.state.worksiteModel.end}
                type="date"
                placeholder={DateFormat}
                name="end"
                alt="worksiteModel"
                invalid={validations.end != null}
                onChange={this.updateState}
              />
              {validations.end}
              {validations.endAfterStart && (
                <div className="srv-validation-message">
                  The end date field must be after start date field
                </div>
              )}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-2 bx--col-lg-2 ">
              <FormLabel>Enabled For Environment</FormLabel>
              <Checkbox
                id="modelisEnabledForEnvironment"
                name="isEnabledForEnvironment"
                required
                labelText=""
                checked={
                  this.state.worksiteModel.isEnabledForEnvironment == null
                    ? false
                    : this.state.worksiteModel.isEnabledForEnvironment
                }
                onChange={(el) => this.updateState('isEnabledForEnvironment', el, 'worksiteModel')}
                className="bx--form-item bx--checkbox-wrapper"
              />
            </FormGroup>
            <FormGroup legendText="" className="bx--col-md-2 bx--col-lg-2 ">
              <FormLabel>Is Offshore</FormLabel>
              <Checkbox
                id="modelisOffshore"
                name="isOffshore"
                required
                labelText=""
                checked={
                  this.state.worksiteModel.isOffshore == null
                    ? false
                    : this.state.worksiteModel.isOffshore
                }
                onChange={(el) => this.updateState('isOffshore', el, 'worksiteModel')}
                className="bx--form-item bx--checkbox-wrapper"
              />
            </FormGroup>
            <FormGroup legendText="" className="bx--col-md-2 bx--col-lg-2 ">
              <FormLabel>Is Saipem</FormLabel>
              <Checkbox
                id="modelisSaipem"
                name="isSaipem"
                required
                labelText=""
                checked={
                  this.state.worksiteModel.isSaipem == null
                    ? false
                    : this.state.worksiteModel.isSaipem
                }
                onChange={(el) => this.updateState('isSaipem', el, 'worksiteModel')}
                className="bx--form-item bx--checkbox-wrapper"
              />
            </FormGroup>
            {/* <FormGroup legendText="" className="bx--col--md-2 bx--col-lg-2 ">
                            <FormLabel>Is Obsolete</FormLabel>
                            <Checkbox id="modelobsolete" name="obsolete" required labelText=""
                                checked={this.state.worksiteModel.obsolete == null ? false : this.state.worksiteModel.obsolete}
                                onChange={el => this.updateState('obsolete', el, 'worksiteModel')}
                                className="bx--form-item bx--checkbox-wrapper" />
                        </FormGroup> */}
            <FormGroup legendText="" className="bx--col-md-2 bx--col-lg-2 ">
              <FormLabel>Asset</FormLabel>
              <Checkbox
                id="modelasset"
                name="asset"
                required
                labelText=""
                checked={
                  this.state.worksiteModel.asset == null ? false : this.state.worksiteModel.asset
                }
                onChange={this.handleChangeAsset}
                className="bx--form-item bx--checkbox-wrapper"
              />
            </FormGroup>
            <FormGroup legendText="" className="bx--col-md-2 bx--col-lg-2 ">
              <FormLabel>Asset Portfolio</FormLabel>
              <Checkbox
                id="modelassetPortfolio"
                name="assetPortfolio"
                required
                labelText=""
                disabled={!(this.state.worksiteModel.asset == true)}
                checked={
                  this.state.worksiteModel.assetPortfolio == null
                    ? false
                    : this.state.worksiteModel.assetPortfolio
                }
                onChange={(el) => this.updateState('assetPortfolio', el, 'worksiteModel')}
                className="bx--form-item bx--checkbox-wrapper"
              />
            </FormGroup>
          </div>
          <div className="bx--row row-add-WsPrj">
            <TableToolbar>
              <Button onClick={() => this.addNewWorkSitePrj()} renderIcon={Add16}>
                Add new Project Link
              </Button>
            </TableToolbar>
            {this.state.worksiteModel ? (
              <DataTable
                rows={this.state.worksiteModel.workSiteProjects || []}
                headers={workSiteProjectsDTHeaders}
                useZebraStyles={true}
                size="compact"
                render={({ rows, headers, getHeaderProps, getRowProps }) => (
                  <TableContainer className="max-width">
                    {
                      <Table className="">
                        <TableHead className="colorgray">
                          <TableRow>
                            {headers.map((header) => (
                              <TableHeader
                                className={header.type == 'bool' ? 'align-center' : ''}
                                {...getHeaderProps({ header })}
                              >
                                {header.header}
                              </TableHeader>
                            ))}
                            <TableHeader className="align-center">Actions</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length == 0 ? (
                            <NoRecordsPlaceholder
                              labelText="No linked project"
                              colSpan={headers.length + 1}
                            />
                          ) : (
                            rows.map((row) => (
                              <TableRow {...getRowProps({ row })}>
                                {row.cells.map((cell) => (
                                  <RenderDataTableCell
                                    key={cell.id}
                                    cell={cell}
                                    header={headers.find((x) => x.key === cell.info.header)}
                                  />
                                ))}

                                <TableCell
                                  key={'action-' + row.id}
                                  className="tableActions align-center"
                                >
                                  <div>
                                    <Button
                                      onClick={() => this.getWorkSitePrjForEdit(row.id)}
                                      size="small"
                                      renderIcon={Edit16}
                                      iconDescription="Edit"
                                      kind="ghost"
                                    />
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    }
                  </TableContainer>
                )}
              />
            ) : null}
          </div>
          <div className="searchFormFooter">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={() => this.closeInsertForm()}
            >
              Cancel
            </Button>
            <Button
              className="button--max-width"
              kind="primary"
              onClick={() => this.handleSubmitInsert()}
            >
              Save
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  renderWorkSiteProjectForm() {
    const validations = {
      start: this.validatorWP.message('start', this.state.workSiteProjectModel.start, 'required'),
      end: this.validatorWP.message('end', this.state.workSiteProjectModel.end, 'required'),
      idProject: this.validatorWP.message(
        'idProject',
        this.state.workSiteProjectModel.idProject,
        'required'
      ),
      idCountry: this.validatorWP.message(
        'idCountry',
        this.state.workSiteProjectModel.idCountry,
        'required'
      ),
      idDivision: this.validatorWP.message(
        'idDivision',
        this.state.workSiteProjectModel.idDivision,
        'required'
      ),
      idSubDivision: this.validatorWP.message(
        'idSubDivision',
        this.state.workSiteProjectModel.idSubDivision,
        'required'
      ),
      idCompany: this.validatorWP.message(
        'idCompany',
        this.state.workSiteProjectModel.idCompany,
        'required'
      ),
      idActivity: this.validatorWP.message(
        'idActivity',
        this.state.workSiteProjectModel.idActivity,
        'required'
      ),
      endAfterStart: this.validatorWP.message(
        'endAfterStart',
        this.state.workSiteProjectModel.end == null ||
          this.state.workSiteProjectModel.start == null ||
          moment(this.state.workSiteProjectModel.end).isSameOrAfter(
            moment(this.state.workSiteProjectModel.start),
            'day'
          ),
        'accepted'
      ),
      startLimit: this.validatorWP.message(
        'startLimit',
        this.state.workSiteProjectModel.start == null ||
          (this.state.worksiteModel.start != null &&
            moment(this.state.workSiteProjectModel.start).isSameOrAfter(
              moment(this.state.worksiteModel.start),
              'day'
            )),
        'accepted'
      ),
      endLimit: this.validatorWP.message(
        'endLimit',
        this.state.workSiteProjectModel.end == null ||
          (this.state.worksiteModel.end != null &&
            moment(this.state.workSiteProjectModel.end).isSameOrBefore(
              moment(this.state.worksiteModel.end),
              'day'
            )),
        'accepted'
      ),
    };

    const propsC = {
      modalHeader: () => ({
        title: (this.state.isEditModalWorkSitePrj ? 'Edit ' : 'Add new ') + 'WorkSite - Prj',
        iconDescription: 'Close',
        buttonOnClick: () => this.toggleModal(false),
      }),
    };
    const consProj =
      this.state.workSiteProjectModel.idProject &&
      this.state.appProject.find((x) => x.value == this.state.workSiteProjectModel.idProject)
        ? this.state.appProject.find((x) => x.value == this.state.workSiteProjectModel.idProject)
            .consolidatedProject
        : '';
    const _appProject = this.state.isEditModalWorkSitePrj
      ? this.state.appProject
      : (this.state.appProject || []).filter((x) => x.inUse == true);
    const listSubDivision = this.state.appSubDivision.filter(
      (x) => x.idDivision == this.state.workSiteProjectModel.idDivision
    );
    const listActivity = this.state.appActivity.filter(
      (x) => x.idDivision == this.state.workSiteProjectModel.idDivision
    );
    return (
      <ComposedModal
        className="light-modal"
        open={this.state.isOpenModal}
        danger="false"
        onClose={() => {
          return false;
        }}
      >
        <ModalHeader className="margin-modal" {...propsC.modalHeader()}>
          <p>{this.state.worksiteModel.name || ''}</p>
        </ModalHeader>
        <ModalBody className="margin-modal">
          <div className="insert-wsprj-form">
            <Form className="bx--grid--full-width">
              <div className="bx--row">
                <FormGroup legendText="" className="bx--col--md-6 bx--col-lg-6">
                  <FormLabel>Date Start*</FormLabel>

                  <DateTimePicker
                    value={this.state.workSiteProjectModel.start}
                    type="date"
                    placeholder={DateFormat}
                    name="start"
                    alt="workSiteProjectModel"
                    invalid={validations.start != null}
                    //disabled={this.state.isEditModalWorkSitePrj}
                    onChange={this.updateState}
                  />
                  {validations.start}
                  {validations.startLimit && (
                    <div className="srv-validation-message">
                      The start date field must be after the WorkSite start date field
                    </div>
                  )}
                </FormGroup>

                <FormGroup legendText="" className="bx--col--md-6 bx--col-lg-6">
                  <FormLabel>Date End*</FormLabel>

                  <DateTimePicker
                    value={this.state.workSiteProjectModel.end}
                    type="date"
                    placeholder={DateFormat}
                    name="end"
                    alt="workSiteProjectModel"
                    invalid={validations.end != null}
                    //disabled={this.state.isEditModalWorkSitePrj}
                    onChange={this.updateState}
                  />
                  {validations.end}
                  {validations.endLimit && (
                    <div className="srv-validation-message">
                      The end date field must be befor the WorkSite end date field
                    </div>
                  )}
                  {validations.endAfterStart && (
                    <div className="srv-validation-message">
                      The end date field must be after start date field
                    </div>
                  )}
                </FormGroup>

                <FormGroup legendText="" className="bx--col--md-6 bx--col-lg-6">
                  <FormLabel>Prj*</FormLabel>
                  {this.state.isLoadingProject ? (
                    <DropdownSkeleton />
                  ) : (
                    <Select
                      id="inputidProject"
                      name="idProject"
                      className="max-width"
                      value={this.state.workSiteProjectModel.idProject || ''}
                      light={true}
                      inline={false}
                      hideLabel={true}
                      disabled={this.state.isEditModalWorkSitePrj}
                      onChange={this.handleChangeWksProjModel}
                      invalid={validations.idProject != null}
                    >
                      <SelectItem value="" text="" />
                      {_appProject.map(({ value, label }, i) => {
                        return <SelectItem key={i} value={value} text={label} />;
                      })}
                    </Select>
                  )}
                  {validations.idProject}
                </FormGroup>

                <FormGroup legendText="" className="bx--col--md-6 bx--col-lg-6">
                  <FormLabel>Consolidated Prj</FormLabel>
                  <TextInput
                    id="consProj"
                    value={consProj || ''}
                    type="text"
                    labelText=""
                    className="bx--text-input  bx--text-input--light force-color"
                    readOnly={true}
                    disabled={true}
                  />
                </FormGroup>

                <FormGroup legendText="" className=" bx--col--md-6 bx--col-lg-6 ">
                  <FormLabel>Country*</FormLabel>
                  {this.state.isLoadingCountry ? (
                    <DropdownSkeleton />
                  ) : (
                    <Select
                      id="inputidCountry"
                      name="idCountry"
                      className="max-width"
                      value={this.state.workSiteProjectModel.idCountry || ''}
                      light={true}
                      inline={false}
                      hideLabel={true}
                      onChange={this.handleChangeWksProjModel}
                      invalid={validations.idCountry != null}
                    >
                      <SelectItem value="" text="" />
                      {this.state.appCountry.map(({ value, label }, i) => {
                        return <SelectItem key={i} value={value} text={label} />;
                      })}
                    </Select>
                  )}
                  {validations.idCountry}
                </FormGroup>

                <FormGroup legendText="" className="bx--col--md-6 bx--col-lg-6 ">
                  {/* RITM0945977 */}
                  {/* <FormLabel>Division*</FormLabel> */}
                  <FormLabel>Business Line*</FormLabel>
                  {this.state.isLoadingDivision ? (
                    <DropdownSkeleton />
                  ) : (
                    <Select
                      id="inputidDivisionp"
                      name="idDivision"
                      className="max-width"
                      value={this.state.workSiteProjectModel.idDivision || ''}
                      light={true}
                      inline={false}
                      hideLabel={true}
                      onChange={this.handleChangeWksProjModel}
                      invalid={validations.idDivision != null}
                    >
                      <SelectItem value="" text="" />
                      {this.state.appDivision.map(({ value, label }, i) => {
                        return <SelectItem key={i} value={value} text={label} />;
                      })}
                    </Select>
                  )}
                  {validations.idDivision}
                </FormGroup>

                <FormGroup legendText="" className=" bx--col--md-6 bx--col-lg-6 ">
                  {/* RITM0945977 */}
                  {/* <FormLabel>SubDivision*</FormLabel> */}
                  <FormLabel>Sub-Business Line*</FormLabel>
                  {this.state.isLoadingSubDivision ? (
                    <DropdownSkeleton />
                  ) : (
                    <Select
                      id="inputidSubDivision"
                      name="idSubDivision"
                      className="max-width"
                      value={this.state.workSiteProjectModel.idSubDivision || ''}
                      light={true}
                      inline={false}
                      hideLabel={true}
                      onChange={this.handleChangeWksProjModel}
                      invalid={validations.idSubDivision != null}
                    >
                      <SelectItem value="" text="" />
                      {listSubDivision.map(({ value, label }, i) => {
                        return <SelectItem key={i} value={value} text={label} />;
                      })}
                    </Select>
                  )}
                  {validations.idSubDivision}
                </FormGroup>

                <FormGroup legendText="" className=" bx--col--md-6 bx--col-lg-6 ">
                  <FormLabel>Operating Company/Branch*</FormLabel>
                  {this.state.isLoadingCompany ? (
                    <DropdownSkeleton />
                  ) : (
                    <Select
                      id="inputidCompany"
                      name="idCompany"
                      className="max-width"
                      value={this.state.workSiteProjectModel.idCompany || ''}
                      light={true}
                      inline={false}
                      hideLabel={true}
                      onChange={this.handleChangeWksProjModel}
                      invalid={validations.idCompany != null}
                    >
                      <SelectItem value="" text="" />
                      {this.state.appCompany.map(({ value, label }, i) => {
                        return <SelectItem key={i} value={value} text={label} />;
                      })}
                    </Select>
                  )}
                  {validations.idCompany}
                </FormGroup>
                      
                <FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6 ">
                    <FormLabel>Local Crisis Unit Registered Office</FormLabel>
                         <Checkbox
                             id="modelIsRegisteredOffice"
                             name="IsRegisteredOffice"
                             labelText=""
                             checked={
                                 this.state.workSiteProjectModel?.isRegisteredOffice == undefined
                                 ? false
                                 : this.state.workSiteProjectModel.isRegisteredOffice
                             }
                             onChange={(el) => this.updateState('isRegisteredOffice', el, 'workSiteProjectModel')}
                             className="bx--form-item bx--checkbox-wrapper"
                          />
                </FormGroup>

                <FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6 ">
                    <FormLabel>HSE Consolidated</FormLabel>
                         <Checkbox
                             id="modelHseConsolidated"
                             name="HseConsolidated"
                             labelText=""
                             checked={
                                 this.state.workSiteProjectModel?.hseConsolidated == undefined
                                 ? false
                                 : this.state.workSiteProjectModel.hseConsolidated
                             }
                             onChange={(el) => this.updateState('hseConsolidated', el, 'workSiteProjectModel')}
                             className="bx--form-item bx--checkbox-wrapper"
                          />
                </FormGroup>
                {/* RITM1398834 Start */}
                <FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6 ">
                    <FormLabel>Under Financial Control</FormLabel>
                    <Select
                      id="idunderFinControl"
                      name="underFinControl"
                      className="max-width"
                      value={this.state.workSiteProjectModel.underFinControl || 'TBD'}
                      light={true}
                      inline={false}
                      hideLabel={true}
                      onChange={this.handleChangeWksProjModel}
                    >
                      <SelectItem key="TBD" value="TBD" text="TBD" />                      
                      <SelectItem key="YES" value="YES" text="YES" />
                      <SelectItem key="NO" value="NO" text="NO" />
                    </Select>
                </FormGroup>
                <FormGroup legendText="" className="bx--col-md-6 bx--col-lg-6 ">
                    <FormLabel>Under Operational Control</FormLabel>
                    <Select
                      id="idunderOpControl"
                      name="underOpControl"
                      className="max-width"
                      value={this.state.workSiteProjectModel.underOpControl || 'TBD'}
                      light={true}
                      inline={false}
                      hideLabel={true}
                      onChange={this.handleChangeWksProjModel}
                    >
                      <SelectItem key="TBD" value="TBD" text="TBD" />                      
                      <SelectItem key="YES" value="YES" text="YES" />
                      <SelectItem key="NO" value="NO" text="NO" />
                    </Select>
                </FormGroup>
                {/* RITM1398834 End */}
                <FormGroup legendText="" className=" bx--col--md-12 bx--col-lg-12 ">
                  <FormLabel>Activity*</FormLabel>
                  {this.state.isLoadingActivity ? (
                    <DropdownSkeleton />
                  ) : (
                    <Select
                      id="inputidActivity"
                      name="idActivity"
                      className="max-width"
                      value={this.state.workSiteProjectModel.idActivity || ''}
                      light={true}
                      inline={false}
                      hideLabel={true}
                      onChange={this.handleChangeWksProjModel}
                      invalid={validations.idActivity != null}
                    >
                      <SelectItem value="" text="" />
                      {listActivity.map(({ value, label }, i) => {
                        return <SelectItem key={i} value={value} text={label} />;
                      })}
                    </Select>
                  )}
                  {validations.idActivity}
                </FormGroup>

                <FormGroup legendText="" className=" bx--col--md-12 bx--col-lg-12 ">
                  <FormLabel>Comments</FormLabel>
                  <TextArea
                    maxLength={5000}
                    id="modelcomments"
                    name="comments"
                    light
                    value={this.state.workSiteProjectModel.comments}
                    rows={4}
                    cols={100}
                    onChange={this.handleChangeWksProjModel}
                    hideLabel={true}
                    labelText=""
                    className="max-width"
                  />
                </FormGroup>
              </div>
            </Form>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.toggleModal(false)}>
            Cancel
          </Button>
          <Button kind="primary" onClick={() => this.saveWorkSitePrj()}>
            Save
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }

  /*************Render********************/

  render() {
    const headersDataTable = [
      { key: 'code', header: 'Code' },
      { key: 'name', header: 'Name' },
      //RITM0945977
      // { key: 'division', header: 'Main Division' },
      { key: 'division', header: 'Main Business Line' },
      { key: 'group', header: 'Worksite Group' },
      { key: 'isOffshore', header: 'Is Offshore', type: 'bool' },
      { key: 'isSaipem', header: 'Is Saipem', type: 'bool' },
        { key: 'isEnabledForEnvironment', header: 'Enabled For Environment', type: 'bool' },
      //RITM0570625
      { key: 'asset', header: 'Asset', type: 'bool' },
      { key: 'assetPortfolio', header: 'Asset Portfolio', type: 'bool' },
      //------------
      //{ key: 'obsolete', header: 'Is Obsolete', 'type': 'bool' },
      { key: 'inUse', header: 'In Use', type: 'bool' },
    ];

    const paginationProps = () => ({
      page: this.state.currentPage || 1,
      totalItems: this.state.rowCount || 0,
      pageSize: this.state.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.handleChangePaging,
    });

    const confirmDelProps = () => ({
      idToDelete: this.state.idToDelete,
      nameItem: this.getNameById(this.state.idToDelete),
      isDeleting: this.state.isDeleting,
      open: this.state.isOpenDeleteModal, //open state
      onCloseConfirm: this.onCloseConfirm, //no click
      deleteItem: this.deleteItem, //yes click fn()
    });

    const skeletonRowCount =
      this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount
        ? this.state.rowCount
        : this.state.pageSize;

    return (
      <>
        {this.state.isOpenInsertModal ? (
          <PageBreadCrumb
            linkText={'WorkSites'}
            titleLeft={this.state.isEditModal ? 'Edit WorkSite' : 'Add new WorkSite'}
            onClick={() => this.closeInsertForm()}
          />
        ) : (
          <PageBreadCrumb linkTo={'/backoffice'} linkText={'BackOffice'} titleLeft={'WorkSites'} />
        )}
        <div className="mainContainer">
          <ConfirmAlertCustom {...confirmDelProps()} />
          {this.state.isOpenInsertModal ? (
            this.renderInsertForm()
          ) : (
            <>
              <TableToolbar>
                <Online>
                  <Search
                    readOnly
                    light
                    className="search cursor-pointer hiddenSearch"
                    labelText="Search"
                    placeHolderText="Search"
                    id="search-1"
                    onClick={this.toggleSearchForm}
                  />

                  <Button
                    onClick={this.toggleSearchForm}
                    className="buttonPaddingIcon"
                    renderIcon={Data16}
                    iconDescription="Filter"
                  />
                  <Button
                    onClick={() => this.downloadFile()}
                    className="btn-notext"
                    iconDescription=" "
                    renderIcon={Download16}
                  >
                    {!this.state.isExportLoading ? '' : <Loading></Loading>}
                  </Button>
                  {this.state.isLoadingModules || this.state.isLoadingRoles ? (
                    <ButtonSkeleton />
                  ) : (
                    <Button onClick={() => this.addNewWorkSite()} renderIcon={Add16}>
                      Add new WorkSite
                    </Button>
                  )}
                </Online>
              </TableToolbar>
              {this.renderSearchform()}
              <DataTable
                rows={this.state.itemList || []}
                headers={headersDataTable}
                useZebraStyles={true}
                size="compact"
                render={({ rows, headers, getHeaderProps, getRowProps }) => (
                  <TableContainer className="bx--grid--full-width">
                    {this.state.isLoadingList ? (
                      <DataTableSkeleton
                        headers={[]}
                        rowCount={skeletonRowCount}
                        zebra={false}
                        compact={false}
                      />
                    ) : (
                      <Table className="">
                        <TableHead className="colorgray">
                          <TableRow>
                            {headers.map((header) => (
                              <TableHeader
                                className={header.type == 'bool' ? 'align-center' : ''}
                                {...getHeaderProps({ header })}
                              >
                                {header.header}
                              </TableHeader>
                            ))}
                            <TableHeader className="align-center">Actions</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length == 0 ? (
                            <NoRecordsPlaceholder colSpan={headers.length + 1} />
                          ) : (
                            rows.map((row) => (
                              <TableRow {...getRowProps({ row })}>
                                {row.cells.map((cell) => (
                                  <RenderDataTableCell
                                    key={cell.id}
                                    cell={cell}
                                    header={headers.find((x) => x.key === cell.info.header)}
                                  />
                                ))}

                                <TableCell
                                  key={'action-' + row.id}
                                  className="tableActions align-center"
                                >
                                  <div>
                                    <Online>
                                      <Button
                                        onClick={() => this.getWorkSiteForEdit(row.id)}
                                        size="small"
                                        renderIcon={Edit16}
                                        iconDescription="Edit"
                                        kind="ghost"
                                      />
                                      <Button
                                        onClick={() => this.confirmDelete(row.id)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                      />
                                    </Online>
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                )}
              />

              <div className="footer-pagination">
                <Pagination {...paginationProps()} />
              </div>
            </>
          )}
          {this.renderWorkSiteProjectForm()}
        </div>
      </>
    );
  }
}
